import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse,HttpInterceptor,HttpRequest,HttpHandler,HttpEvent  } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
//import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Access-Control-Request-Method': 'GET,POST,PUT,DELETE,OPTIONS',
  })
};

const httpFileOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'multipart/form-data'
  })
};

@Injectable({
  providedIn: 'root'
})
export class DataService {
  baseURL: any;
  url: any;
  lastUpdatedAt = new Subject();

  constructor(private http: HttpClient, private router: Router) {
    this.baseURL = environment.apiBase;
  }

  getService(apiUrl: string): Observable<any> {
    console.log("Get Service");
    this.url = this.baseURL + apiUrl;
    console.log("Get Service",this.url);
    return this.http.get<any[]>(this.url, { responseType: 'json' })
    .pipe(
      catchError(this.handleError(apiUrl, []))
    );
  }

  postService(apiUrl: string, data: any): Observable<any> {
    this.url = this.baseURL + apiUrl;
    return this.http.post(this.url, data, { responseType: 'json' })
    .pipe(
      tap((user: any) => console.log(`Operation Performed Successfully`)),
      catchError(this.handleError(apiUrl, []))
    );
  }


  postService1(apiUrl: string, data: any): Observable<any> {
    this.url = this.baseURL + apiUrl;
    return this.http.post(this.url, data, { responseType: 'json' })
    .pipe(
      tap((user: any) => console.log(`Operation Performed Successfully`)),
      catchError(this.handleError(apiUrl, []))
    );
  }



  fileService(apiUrl: string, data: any): Observable<any> {
    this.url = this.baseURL + apiUrl;
    return this.http.post(this.url, data, httpFileOptions)
    .pipe(
      tap((user: any) => console.log(`Operation Performed Successfully`)),
      catchError(this.handleError(apiUrl, []))
    );
  }

  deleteService(apiUrl: string): Observable<any> {
    this.url = this.baseURL + apiUrl;
    return this.http.delete(this.url, { responseType: 'json' });
  }

  putService(apiUrl: string, data: any): Observable<any> {
    this.url = this.baseURL + apiUrl;
    return this.http.put(this.url, data, { responseType: 'json' });
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  setLastUpdateAt (data:any){
    this.lastUpdatedAt.next(data);
  }

}
